module.exports = __webpack_public_path__ + "img/car_00059.a9f8ae9f.jpg";